const SHOPIFY_STOREFRONT_API_URL = `https://${Shopify.shop}/api/2026-04/graphql.json`;
const STOREFRONT_ACCESS_TOKEN = "f658edc313647d6453f53e94ba7b1b6b";
const sinaform = document.querySelector("form#sina-options");
const confirmButton = sinaform.querySelector("#add-to-cart");
const jobField = sinaform.querySelector("#job-name");
const inhouseQuantity = sinaform.querySelector('[data-inhouse]#qty');
const shipCostHolder = sinaform.querySelector('.shipping-estimate');
const shipCostSpan = shipCostHolder.querySelector('span[data-ship-cost]');
const shipZip = shipCostHolder.querySelector("#zips");
var productHashes = null;
var customCosts = {};
var sinacost = 0;
var __packageInfo = "";
var servicescost = 0;
var finishingscost = 0;
var inhousecost = 0;
var __sinaliteData = {};

var sizeFld = sinaform.querySelector("#size[data-basics]");
var qtyFld = sinaform.querySelector("#qty[data-basics]");

var customQtyCheck = sinaform.querySelector("#custom-qty");
var customSizeCheck = sinaform.querySelector("#custom-size");
var customSizeHolder = sinaform.querySelector(".customSizeHolder");

var customQty = sinaform.querySelector("[name=customQty]");
var customWidth = sinaform.querySelector("[name=customWidth]");
var customHeight = sinaform.querySelector("[name=customHeight]");

var minCustomWidthHeight = sizeFld ? Array.from(sizeFld?.querySelectorAll("option"))
  .map(option => option.innerText.toLowerCase().trim().split("x"))
    .flat().map(option => option.trim() * 1).sort((a,b) => a-b)[0] : null;

Array.from([customWidth, customHeight]).filter(field => field).forEach(field => field.setAttribute("min",minCustomWidthHeight));

customQtyCheck?.addEventListener("change",function(){
  customQty.style.display = this.checked ? "block" : "none";
  customQty.setAttribute("form",this.checked ? "" : "custom");
  qtyFld.parentNode.style.display = !this.checked ? "" : "none";
  return this.checked ? [qtyFld.setAttribute("form", "custom"), customQty.removeAttribute("form"), fetchPrice()]
    : [qtyFld.removeAttribute("form"), customQty.setAttribute("form","custom"), fetchPrice()];
});

customSizeCheck?.addEventListener("change",function(){
  customSizeHolder.style.display = this.checked ? "flex" : "none";
  customWidth.setAttribute("form",this.checked ? "" : "custom");
  customHeight.setAttribute("form",this.checked ? "" : "custom");
  sizeFld.parentNode.style.display = !this.checked ? "" : "none";
  return this.checked ? [sizeFld.setAttribute("form", "custom"), customWidth.removeAttribute("form"), customHeight.removeAttribute("form"), fetchPrice()]
    : [sizeFld.removeAttribute("form"), customWidth.setAttribute("form","custom"), customHeight.setAttribute("form","custom"), fetchPrice()];
});

const gqlQuery = `query product($gqID: ID!) {
  product(id: $gqID) {
    services: metafield(namespace: "additional", key: "servicings") {
      references(first: 50) {
        edges { node {
            ... on Metaobject {
              fields {
                key value
                references(first: 50) {
                  edges { node {
                      ... on Metaobject {
                        fields { key value }
                      }
                  } }
                }
              }
            }
        } }
      }
    }
    finishings: metafield(namespace: "additional", key: "finishings") {
      references(first: 50) {
        edges { node {
            ... on Metaobject {
              fields {
                key value
                references(first: 50) {
                  edges { node {
                      ... on Metaobject {
                        fields { key value }
                      }
                  } }
                }
              }
            }
        } }
      }
    }
  }
}`;

async function getShippingEstimate(packageInfo) {
    if( shipZip.value.replace(/ /g,"").length < 6 ) return;
    const res = await fetch("/apps/manager/shipping-estimate", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ packageInfo, postalCode: shipZip.value })
    });

    if (!res.ok) {
        const err = await res.json();
        throw new Error(err.message ?? "Failed to get shipping estimate");
    }

    const { charge } = await res.json();
    shipCostSpan.innerHTML = parseFloat(charge).toFixed(2);
}

shipZip.addEventListener("change",function(){ getShippingEstimate(__packageInfo) });

function formatCurrency(amount) {
  return Intl.NumberFormat(navigator.language, {
    style: "currency",
    currency: Shopify.currency.active,
  }).format(amount);
}

async function getCostData(productId) {
  if (!customCosts[productId]) {
    const gqID = `gid://shopify/Product/${productId}`;
    const response = await fetch(SHOPIFY_STOREFRONT_API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": STOREFRONT_ACCESS_TOKEN,
      },
      body: JSON.stringify({
        query: gqlQuery,
        variables: { gqID },
      }),
    });
    const result = await response.json();
    if (!response.ok || result.errors) {
      throw new Error("Failed to fetch data from Shopify Storefront API");
    }
    customCosts[productId] = result.data.product;
  }
  return extractPricingData(customCosts[productId]);
}

function extractPricingData(graphqlData) {
  const pricingData = {};
  const extractOptions = (name, options) => {
    pricingData[name] = {};
    options.forEach((option) => {
      let optionName = option.find((o) => o.key === "name").value,
        set_up_fee =
          JSON.parse(option.find((o) => o.key === "set_up_fee").value).amount *
          1,
        price_per =
          JSON.parse(option.find((o) => o.key === "price_per").value).amount *
          1,
        items = option.find((o) => o.key === "items").value * 1;

      pricingData[name][optionName] = {
        set_up_fee,
        price_per,
        items,
      };
    });
  };

  const serviceEdges = graphqlData?.services?.references?.edges || [];
  serviceEdges.forEach(({ node }) => {
    const fields = node.fields || [];
    const name =
      fields.find((field) => field.key === "name").value || "No name";
    const options =
      fields
        .find((field) => field.key === "options")
        ?.references?.edges?.map((edge) => edge.node.fields) || [];
    extractOptions("Service: " + name, options);
  });

  const finishingEdges = graphqlData?.finishings?.references?.edges || [];
  finishingEdges.forEach(({ node }) => {
    const fields = node.fields || [];
    const name =
      fields.find((field) => field.key === "name").value || "No name";
    const options =
      fields
        .find((field) => field.key === "options")
        ?.references?.edges?.map((edge) => edge.node.fields) || [];
    extractOptions("Finishing: " + name, options);
  });
  return pricingData;
}

if (sinaform.dataset.category != "Roll Labels / Stickers"){
  [sizeFld, qtyFld].filter(core => core).forEach(core => core.addEventListener("change",buildHashes));
}

function buildHashes(){
  var options = Array.from(sinaform.querySelectorAll("[data-basics]")).filter(
    (option) => !["qty", "size"].includes(option.id.toLowerCase())
  );
  options.forEach(option => {
    let values = option.querySelectorAll("option");
    let sizeFldValue = sizeFld.querySelectorAll("option")[sizeFld.selectedIndex].id.toLowerCase();
    let qtyFldValue = qtyFld.querySelectorAll("option")[qtyFld.selectedIndex].id.toLowerCase();

    values.forEach(value => {
      let MD5String = `#${option.id.toLowerCase()}#${value.id.toLowerCase()}#size#${sizeFldValue}#qty#${qtyFldValue}`;
      let MD5Value = MD5(MD5String);

      value.removeAttribute("disabled");
      if(productHashes && productHashes.length > 0 && !productHashes.includes(MD5Value)) value.setAttribute("disabled","disabled");
    })
  });
}

async function fetchPrice() {
  const isCustom = customSizeCheck?.checked || customQtyCheck?.checked;

  sinacost = 0;
  jobField.setAttribute("form", "null");
  confirmButton.removeAttribute("disabled");
  confirmButton.classList.add("loading");

  if (!sinaform.reportValidity()) return jobField.removeAttribute("form");

  let productOptions = Object.fromEntries(new FormData(sinaform));

  if( sinaform.dataset.category == "In House" ) {
    confirmButton.classList.remove("loading");
    sinaform
      .querySelectorAll("[data-customizations], #job-name")
      .forEach((elm) => elm.removeAttribute("form"));
    return finalizePrice();
  }

  if (isCustom) {
    var options = Array.from(sinaform.querySelectorAll("[data-basics],[data-custom]"));
    var pData = {};

    options.forEach(option => {
      pData[option.name] = option.value;
    });

    if(pData.customWidth && pData.customHeight) pData.size = `${pData.customWidth} x ${pData.customHeight}`;
    if(pData.customQty) pData.qty = pData.customQty;
    pData.SINAPLUS = "false";

    delete pData.customQty;
    delete pData.customWidth;
    delete pData.customHeight;
    delete pData['custom-size'];
    delete pData['custom-qty'];
    productOptions = pData;
  } else if (sinaform.dataset.category != "Roll Labels / Stickers") {
    var qty = qtyFld.querySelectorAll("option")[qtyFld.selectedIndex]
      .id.toLowerCase();
    var size = sizeFld.querySelectorAll("option")[sizeFld.selectedIndex]
      .id.toLowerCase();

    var options = Array.from(sinaform.querySelectorAll("[data-basics]")).filter(
      (option) => !["qty", "size"].includes(option.id.toLowerCase())
    );

    options.forEach(
      (option) =>
        (option
          .closest(".sina-option-holder")
          .querySelector("span[data-error]").dataset.error = "")
    );

    var hashes = options.map(
      (option) =>
        `#${option.id.toLowerCase()}#${option
          .querySelectorAll("option")
          [option.selectedIndex].id.toLowerCase()}#size#${size}#qty#${qty}`
    );

    var validHashes = await fetch("/apps/manager/validate-hashes", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        hashes,
        product_id: sinaform.dataset.sinaProduct,
      }),
    }).then((data) => data.json());

    validHashes.forEach((valid, i) => {
      if (!valid)
        options[i]
          .closest(".sina-option-holder")
          .querySelector("span[data-error]").dataset.error =
          "Invalid selection for the selected quantity and size.";
    });

    if (!validHashes.reduce((c, h) => c && h, true))
      return [
        confirmButton.classList.remove("loading"),
        confirmButton.setAttribute("disabled", "disabled")
      ];

    productOptions = Object.keys(productOptions).map((key) => {
      let prop = sinaform.querySelector(`[name="${key}"]`);
      return prop.querySelectorAll("option")[prop.selectedIndex]?.dataset?.sinavalue;
    }).filter(option => option);
  } else {
    if(productOptions?.shape === "square") productOptions.length = productOptions.width;
  }

  __sinaliteData = JSON.stringify({
    productId: sinaform.dataset.sinaProduct,
    productOptions
  });

  let postData = {
    id: sinaform.dataset.sinaProduct,
    productOptions,
  };

  jobField.removeAttribute("form");
  fetch("/apps/manager/get-sina-price", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(postData),
  })
    .then((data) => data.json())
    .then((data) => {
      sinacost = data.price * 1;
      __packageInfo = data.__packageInfo;
      confirmButton.classList.remove("loading");
      sinaform
        .querySelectorAll("[data-customizations], #job-name")
        .forEach((elm) => elm.removeAttribute("form"));
      finalizePrice();
    });
}

async function finalizePrice() {
  servicescost = 0;
  finishingscost = 0;

  const isCustom = customSizeCheck?.checked || customQtyCheck?.checked;

  let quantity = sinaform.elements['customQty']?.value ?? sinaform.elements.qty?.value;
  let productId = sinaform.dataset.product;
  let customizationsCostChart = await getCostData(productId, quantity);
  let customizationsCost = 0;

  if( inhouseQuantity ){
    let selectedVariant = sinaform.dataset.variant;
    selectedVariant = __variants.find((variant) =>
      variant.option1 == sinaform.querySelector('[data-inhouse="option1"]').value
      && variant.option2 == sinaform.querySelector('[data-inhouse="option2"]').value
      && variant.option3 == sinaform.querySelector('[data-inhouse="option3"]').value
    );
    sinaform.dataset.variant = selectedVariant?.id || sinaform.dataset.variant;
    inhousecost = (selectedVariant.price / 100);
  }

  sinaform
    .querySelectorAll("[data-customizations]")
    .forEach((customization) => {
      let thisAddonCost = sinaform.querySelector(
        "addon-cost[name='" + customization.name + "']"
      );
      let customizationCosts =
        customizationsCostChart[customization.name][customization.value];
      let scaleFactor = Math.ceil(quantity / customizationCosts.items);
      let customizationCost =
        customizationCosts.set_up_fee +
        customizationCosts.price_per * scaleFactor;
      thisAddonCost.innerHTML = `Adds ${formatCurrency(
        customizationCost
      )} to the cost`;

      if (customization.dataset.customizations == "services")
        servicescost += customizationCost;
      else finishingscost += customizationCost;
    });

  await getShippingEstimate(__packageInfo);
  document.querySelectorAll(
    ".product-details [ref=\"priceContainer\"] .price"
  ).forEach(priceElm => priceElm.innerHTML = formatCurrency(sinacost + inhousecost + servicescost + finishingscost));
}

["change", "keyup"].forEach(evt => 
    jobField.addEventListener(evt, function () {
        jobField.setCustomValidity('');
        if (jobField.value && !jobField.value.match(jobField.dataset.pattern)) {
            jobField.setCustomValidity('Invalid character. Please use alphabets, numbers, dashes (-) and underscores (_) only');
            return jobField.reportValidity();
        }
    })
);

sinaform
  .querySelectorAll("input[data-basics], select[data-basics]")
  .forEach((option) => option.addEventListener("change", fetchPrice));

if(customQty) customQty.addEventListener("change",fetchPrice);
if(customHeight) customHeight.addEventListener("change",fetchPrice);
if(customWidth) customWidth.addEventListener("change",fetchPrice);

sinaform
  .querySelectorAll("[data-customizations]")
  .forEach((customization) =>
    customization.addEventListener("change", finalizePrice)
  );

confirmButton.addEventListener("click", function (e) {
  e.preventDefault();

  jobField.setCustomValidity('');

  if( jobField.value && !jobField.value.match(jobField.dataset.pattern) ){
    jobField.setCustomValidity('Invalid character. Please use alphabets, numbers, dashes (-) and underscores (_) only');
    return jobField.reportValidity();
  }

  if (!sinaform.reportValidity()) return;

  jobField.setAttribute("form", "null");

  sinaform
    .querySelectorAll("[data-customizations]")
    .forEach((customization) =>
      customization.setAttribute("form", customization.dataset.customizations)
    );

  /* Build 

  /** Build order lineitems */
  let lineItems = new Array();

  /** Build basic product */
  let lineItem = {
    variantId: `gid://shopify/ProductVariant/${sinaform.dataset.variant}`,
    quantity: (sinaform.elements['customQty']?.value ?? sinaform.elements.qty?.value) * 1,
    generatePriceOverride: true,
    priceOverride: {
      amount: (Math.round(((sinacost + inhousecost) * 100) / (sinaform.elements['customQty']?.value ?? sinaform.elements.qty?.value)) / 100) + servicescost + finishingscost,
      currencyCode: Shopify.currency.active,
    },
    requiresShipping: true,
    customAttributes: Array.from(sinaform.elements).reduce(
      (a, elm) => {
        if(elm.name) a.push({
          key: elm.name.replace("Service: ", ""),
          value: elm.value,
        });
        return a;
      },
      [
        { key: "Job", value: jobField.value },
        { key: "__sinaliteProduct", value: "true" },
        { key: "__sinaliteData", value: __sinaliteData },
        { key:"__packageInfo", value:__packageInfo }
      ]
    ),
  };
  /** Build Services Product */
  let services = Array.from(document.forms.services.elements).reduce(
    (a, elm) => {
      a.push({ key: elm.name.replace("Service: ", ""), value: elm.value });
      return a;
    },
    []
  );
  if (services.length) {
    lineItem.customAttributes.push({
      key: "Services",
      value: services
    });
    lineItems.push({
      title: `Services`,
      quantity: 1,
      requiresShipping: false,
      customAttributes: services,
      originalUnitPriceWithCurrency: {
        amount: servicescost,
        currencyCode: Shopify.currency.active,
      },
    });
  }
  /** Build Finishings Product */
  let finishings = Array.from(document.forms.finishings.elements).reduce(
    (a, elm) => {
      a.push({ key: elm.name.replace("Finishing: ", ""), value: elm.value });
      return a;
    },
    []
  );
  if (finishings.length) {
    lineItem.customAttributes.push({
      key: "Finishings",
      value: finishings
    });
    lineItems.push({
      title: `Finishings`,
      quantity: 1,
      requiresShipping: false,
      customAttributes: finishings,
      originalUnitPriceWithCurrency: {
        amount: finishingscost,
        currencyCode: Shopify.currency.active,
      },
    });
  }
  /** End order lineitems */

  /** Build Order Payload */
  /* let orderData = {
    customerId: `gid://shopify/Customer/${sinaform.dataset.customer}`,
    lineItems,
  }; */

  lineItem.customAttributes.push({
    key: "__finalPrice",
    value: [
      {key:"sinacost",value:sinacost},
      {key:"inhousecost",value:inhousecost},
      {key:"servicescost",value:servicescost},
      {key:"finishingscost",value:finishingscost}
    ]
  });

  let cartData = {
    items: [{
      quantity: 1,
      id: sinaform.dataset.variant,
      properties: lineItem.customAttributes.reduce((a,prop) => {
        a[prop.key] = prop.value;
        return a;
      },{})
    }]
  };

  confirmButton.setAttribute("disabled","disabled");
  confirmButton.classList.add("loading");

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(cartData)
  })
  .then(async (response) => {
    confirmButton.classList.toggle("loading");
    confirmButton.classList.toggle("added");
    return location.href = "/cart";
  })
  .catch((error) => console.error('Error:', error) )
});

const MD5 = (string) => {

   function RotateLeft(lValue, iShiftBits) {
           return (lValue<<iShiftBits) | (lValue>>>(32-iShiftBits));
   }

   function AddUnsigned(lX,lY) {
           var lX4,lY4,lX8,lY8,lResult;
           lX8 = (lX & 0x80000000);
           lY8 = (lY & 0x80000000);
           lX4 = (lX & 0x40000000);
           lY4 = (lY & 0x40000000);
           lResult = (lX & 0x3FFFFFFF)+(lY & 0x3FFFFFFF);
           if (lX4 & lY4) {
                   return (lResult ^ 0x80000000 ^ lX8 ^ lY8);
           }
           if (lX4 | lY4) {
                   if (lResult & 0x40000000) {
                           return (lResult ^ 0xC0000000 ^ lX8 ^ lY8);
                   } else {
                           return (lResult ^ 0x40000000 ^ lX8 ^ lY8);
                   }
           } else {
                   return (lResult ^ lX8 ^ lY8);
           }
   }

   function F(x,y,z) { return (x & y) | ((~x) & z); }
   function G(x,y,z) { return (x & z) | (y & (~z)); }
   function H(x,y,z) { return (x ^ y ^ z); }
   function I(x,y,z) { return (y ^ (x | (~z))); }

   function FF(a,b,c,d,x,s,ac) {
           a = AddUnsigned(a, AddUnsigned(AddUnsigned(F(b, c, d), x), ac));
           return AddUnsigned(RotateLeft(a, s), b);
   };

   function GG(a,b,c,d,x,s,ac) {
           a = AddUnsigned(a, AddUnsigned(AddUnsigned(G(b, c, d), x), ac));
           return AddUnsigned(RotateLeft(a, s), b);
   };

   function HH(a,b,c,d,x,s,ac) {
           a = AddUnsigned(a, AddUnsigned(AddUnsigned(H(b, c, d), x), ac));
           return AddUnsigned(RotateLeft(a, s), b);
   };

   function II(a,b,c,d,x,s,ac) {
           a = AddUnsigned(a, AddUnsigned(AddUnsigned(I(b, c, d), x), ac));
           return AddUnsigned(RotateLeft(a, s), b);
   };

   function ConvertToWordArray(string) {
           var lWordCount;
           var lMessageLength = string.length;
           var lNumberOfWords_temp1=lMessageLength + 8;
           var lNumberOfWords_temp2=(lNumberOfWords_temp1-(lNumberOfWords_temp1 % 64))/64;
           var lNumberOfWords = (lNumberOfWords_temp2+1)*16;
           var lWordArray=Array(lNumberOfWords-1);
           var lBytePosition = 0;
           var lByteCount = 0;
           while ( lByteCount < lMessageLength ) {
                   lWordCount = (lByteCount-(lByteCount % 4))/4;
                   lBytePosition = (lByteCount % 4)*8;
                   lWordArray[lWordCount] = (lWordArray[lWordCount] | (string.charCodeAt(lByteCount)<<lBytePosition));
                   lByteCount++;
           }
           lWordCount = (lByteCount-(lByteCount % 4))/4;
           lBytePosition = (lByteCount % 4)*8;
           lWordArray[lWordCount] = lWordArray[lWordCount] | (0x80<<lBytePosition);
           lWordArray[lNumberOfWords-2] = lMessageLength<<3;
           lWordArray[lNumberOfWords-1] = lMessageLength>>>29;
           return lWordArray;
   };

   function WordToHex(lValue) {
           var WordToHexValue="",WordToHexValue_temp="",lByte,lCount;
           for (lCount = 0;lCount<=3;lCount++) {
                   lByte = (lValue>>>(lCount*8)) & 255;
                   WordToHexValue_temp = "0" + lByte.toString(16);
                   WordToHexValue = WordToHexValue + WordToHexValue_temp.substr(WordToHexValue_temp.length-2,2);
           }
           return WordToHexValue;
   };

   function Utf8Encode(string) {
           string = string.replace(/\r\n/g,"\n");
           var utftext = "";

           for (var n = 0; n < string.length; n++) {

                   var c = string.charCodeAt(n);

                   if (c < 128) {
                           utftext += String.fromCharCode(c);
                   }
                   else if((c > 127) && (c < 2048)) {
                           utftext += String.fromCharCode((c >> 6) | 192);
                           utftext += String.fromCharCode((c & 63) | 128);
                   }
                   else {
                           utftext += String.fromCharCode((c >> 12) | 224);
                           utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                           utftext += String.fromCharCode((c & 63) | 128);
                   }

           }

           return utftext;
   };

   var x=Array();
   var k,AA,BB,CC,DD,a,b,c,d;
   var S11=7, S12=12, S13=17, S14=22;
   var S21=5, S22=9 , S23=14, S24=20;
   var S31=4, S32=11, S33=16, S34=23;
   var S41=6, S42=10, S43=15, S44=21;

   string = Utf8Encode(string);

   x = ConvertToWordArray(string);

   a = 0x67452301; b = 0xEFCDAB89; c = 0x98BADCFE; d = 0x10325476;

   for (k=0;k<x.length;k+=16) {
           AA=a; BB=b; CC=c; DD=d;
           a=FF(a,b,c,d,x[k+0], S11,0xD76AA478);
           d=FF(d,a,b,c,x[k+1], S12,0xE8C7B756);
           c=FF(c,d,a,b,x[k+2], S13,0x242070DB);
           b=FF(b,c,d,a,x[k+3], S14,0xC1BDCEEE);
           a=FF(a,b,c,d,x[k+4], S11,0xF57C0FAF);
           d=FF(d,a,b,c,x[k+5], S12,0x4787C62A);
           c=FF(c,d,a,b,x[k+6], S13,0xA8304613);
           b=FF(b,c,d,a,x[k+7], S14,0xFD469501);
           a=FF(a,b,c,d,x[k+8], S11,0x698098D8);
           d=FF(d,a,b,c,x[k+9], S12,0x8B44F7AF);
           c=FF(c,d,a,b,x[k+10],S13,0xFFFF5BB1);
           b=FF(b,c,d,a,x[k+11],S14,0x895CD7BE);
           a=FF(a,b,c,d,x[k+12],S11,0x6B901122);
           d=FF(d,a,b,c,x[k+13],S12,0xFD987193);
           c=FF(c,d,a,b,x[k+14],S13,0xA679438E);
           b=FF(b,c,d,a,x[k+15],S14,0x49B40821);
           a=GG(a,b,c,d,x[k+1], S21,0xF61E2562);
           d=GG(d,a,b,c,x[k+6], S22,0xC040B340);
           c=GG(c,d,a,b,x[k+11],S23,0x265E5A51);
           b=GG(b,c,d,a,x[k+0], S24,0xE9B6C7AA);
           a=GG(a,b,c,d,x[k+5], S21,0xD62F105D);
           d=GG(d,a,b,c,x[k+10],S22,0x2441453);
           c=GG(c,d,a,b,x[k+15],S23,0xD8A1E681);
           b=GG(b,c,d,a,x[k+4], S24,0xE7D3FBC8);
           a=GG(a,b,c,d,x[k+9], S21,0x21E1CDE6);
           d=GG(d,a,b,c,x[k+14],S22,0xC33707D6);
           c=GG(c,d,a,b,x[k+3], S23,0xF4D50D87);
           b=GG(b,c,d,a,x[k+8], S24,0x455A14ED);
           a=GG(a,b,c,d,x[k+13],S21,0xA9E3E905);
           d=GG(d,a,b,c,x[k+2], S22,0xFCEFA3F8);
           c=GG(c,d,a,b,x[k+7], S23,0x676F02D9);
           b=GG(b,c,d,a,x[k+12],S24,0x8D2A4C8A);
           a=HH(a,b,c,d,x[k+5], S31,0xFFFA3942);
           d=HH(d,a,b,c,x[k+8], S32,0x8771F681);
           c=HH(c,d,a,b,x[k+11],S33,0x6D9D6122);
           b=HH(b,c,d,a,x[k+14],S34,0xFDE5380C);
           a=HH(a,b,c,d,x[k+1], S31,0xA4BEEA44);
           d=HH(d,a,b,c,x[k+4], S32,0x4BDECFA9);
           c=HH(c,d,a,b,x[k+7], S33,0xF6BB4B60);
           b=HH(b,c,d,a,x[k+10],S34,0xBEBFBC70);
           a=HH(a,b,c,d,x[k+13],S31,0x289B7EC6);
           d=HH(d,a,b,c,x[k+0], S32,0xEAA127FA);
           c=HH(c,d,a,b,x[k+3], S33,0xD4EF3085);
           b=HH(b,c,d,a,x[k+6], S34,0x4881D05);
           a=HH(a,b,c,d,x[k+9], S31,0xD9D4D039);
           d=HH(d,a,b,c,x[k+12],S32,0xE6DB99E5);
           c=HH(c,d,a,b,x[k+15],S33,0x1FA27CF8);
           b=HH(b,c,d,a,x[k+2], S34,0xC4AC5665);
           a=II(a,b,c,d,x[k+0], S41,0xF4292244);
           d=II(d,a,b,c,x[k+7], S42,0x432AFF97);
           c=II(c,d,a,b,x[k+14],S43,0xAB9423A7);
           b=II(b,c,d,a,x[k+5], S44,0xFC93A039);
           a=II(a,b,c,d,x[k+12],S41,0x655B59C3);
           d=II(d,a,b,c,x[k+3], S42,0x8F0CCC92);
           c=II(c,d,a,b,x[k+10],S43,0xFFEFF47D);
           b=II(b,c,d,a,x[k+1], S44,0x85845DD1);
           a=II(a,b,c,d,x[k+8], S41,0x6FA87E4F);
           d=II(d,a,b,c,x[k+15],S42,0xFE2CE6E0);
           c=II(c,d,a,b,x[k+6], S43,0xA3014314);
           b=II(b,c,d,a,x[k+13],S44,0x4E0811A1);
           a=II(a,b,c,d,x[k+4], S41,0xF7537E82);
           d=II(d,a,b,c,x[k+11],S42,0xBD3AF235);
           c=II(c,d,a,b,x[k+2], S43,0x2AD7D2BB);
           b=II(b,c,d,a,x[k+9], S44,0xEB86D391);
           a=AddUnsigned(a,AA);
           b=AddUnsigned(b,BB);
           c=AddUnsigned(c,CC);
           d=AddUnsigned(d,DD);
   		}

   	var temp = WordToHex(a)+WordToHex(b)+WordToHex(c)+WordToHex(d);

   	return temp.toLowerCase();
}

document.addEventListener("DOMContentLoaded",async function () {
  if( sinaform.dataset.category != "Roll Labels / Stickers" ) {
    await fetch("/apps/manager/get-product-hashes/"+sinaform.dataset.sinaProduct)
      .then(hashes => hashes.json())
      .then(hashes => productHashes = hashes)
      .then(() => buildHashes());
  }
  return fetchPrice();
})